/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Custom_Pages_ExtensionInputs */

const en_tables_custom_pages_extension = /** @type {(inputs: Tables_Custom_Pages_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

const de_tables_custom_pages_extension = /** @type {(inputs: Tables_Custom_Pages_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extension`)
};

/**
* | output |
* | --- |
* | "Extension" |
*
* @param {Tables_Custom_Pages_ExtensionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_custom_pages_extension = /** @type {((inputs?: Tables_Custom_Pages_ExtensionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Custom_Pages_ExtensionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_custom_pages_extension(inputs)
	return de_tables_custom_pages_extension(inputs)
});